import React from 'react'

import AdminActions from '../../../../actions/AdminActions.js'

import {Alert, Button, IconButton, H4, H6} from '../../../../components/UI/index.js'
import {formSpacing, Input, CurrencyInput, Check, Select, Toggle, TextArea, DatePicker, FormRow, FormStack} from '../../../../components/UI/forms/index.js'
import RemovePopup from './RemovePopup.js'
import ArchivePopup from './ArchivePopup.js'
import {parsePrice} from '../../../../../utils/price.js'
import t from '../../../../helpers/Languages.js'
import _ from 'lodash'

class EditReseller extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            reseller: JSON.parse(JSON.stringify(props.reseller)),
            user: {
                name: '',
                firstName: '',
                lastName: '',
                address: {
                    name: '',
                    street: '',
                    nr: '',
                    addition: '',
                    street2: '',
                    postalCode: '',
                    city: '',
                    country: 'NL'
                },
                email: '',
                phone: '',
                settings: {
                    customSpeed: 0,
                    speedDifference: 0,
                    stopTime: 0
                },
                permissions: {
                    orders: false,
                    parcels: false,
                    shifts: false,
                    subscriptions: false,
                    customers: false,
                    invoices: false,
                    users: false,
                    vehicles: false,
                    paychecks: false,
                    network: false
                }
            },
            loading: false,
            message: '',
            error: ''
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reseller !== this.props.reseller) {
            this.setState({reseller: JSON.parse(JSON.stringify(this.props.reseller))})
        }
    }

    onChangePrice(category, index, key, event) {
        const reseller = {...this.state.reseller}

        reseller.prices[category][index][key] = event.target.value

        this.setState({reseller})
    }

    onClickAddPrice(category) {
        const reseller = {...this.state.reseller}

        const previousPrice = reseller.prices[category][reseller.prices[category].length - 1]

        if (previousPrice) {
            reseller.prices[category].push({max: previousPrice.max, price: previousPrice.price})
        } else {
            reseller.prices[category].push({max: 100, price: '0,00'})
        }

        this.setState({reseller})
    }

    onClickRemovePrice(category, index) {
        const reseller = {...this.state.reseller}

        reseller.prices[category].splice(index, 1)

        this.setState({reseller})
    }

    onChangeValue(category, key, event) {
        const reseller = {...this.state.reseller}

        if (category) {
            reseller[category][key] = event.target.value
        } else {
            reseller[key] = event.target.value
        }

        if (key === 'accountType') {
            reseller.permissions.parcels = event.target.value === 'carrierPlus'
            reseller.permissions.vehicles = event.target.value === 'carrierPlus'
            reseller.permissions.analytics = event.target.value === 'carrierPlus'
            reseller.permissions.network = event.target.value === 'carrierPlus'
        }

        if (key === 'nrOfFreeLicenses' || key === 'minNrOfLicenses') {
            reseller.prices[key] = parseInt(event.target.value) || 0
        }

        this.setState({reseller})
    }

    onChangeValues(path, event) {
        const reseller = {...this.state.reseller}

        _.set(reseller, path, event.target.values)

        this.setState({reseller})
    }

    onChangeChecked(category, key, event) {
        const reseller = {...this.state.reseller}

        if (category) {
            reseller[category][key] = event.target.checked
        } else {
            reseller[key] = event.target.checked
        }

        this.setState({reseller})
    }

    onChangeValueUser(key, event) {
        const user = {...this.state.user}

        if (key === 'email') {
            user[key] = event.target.value.toLowerCase()
        } else {
            user[key] = event.target.value
        }

        this.setState({user})
    }

    onClickSave() {
        const {reseller, user} = this.state

        this.setState({loading: true, message: '', error: ''})

        AdminActions.updateReseller(reseller, reseller._id ? null : user, (err) => {
            if (err) {
                this.setState({loading: false, error: err})
            } else {
                this.setState({loading: false, message: 'Je wijzigingen zijn opgeslagen'})
            }
        })
    }

    onClickCancel() {
        AdminActions.selectReseller(null)
    }

    render() {
        const {reseller, user, loading, message, error} = this.state
        const {resellers, viewArchived} = this.props

        const groupOptions = [...new Set([...resellers.flatMap(({groups}) => groups || []), ...reseller.groups || []])]
            .sort()
            .map((group) => ({value: group, title: group}))

        return (
            <>
                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Naam'
                        value={(reseller.settings?.accountName && reseller.settings?.accountName !== reseller.name) ? `${reseller.settings.accountName} (${reseller.name})` : reseller.name}
                        disabled={reseller._id}
                        onChange={this.onChangeValue.bind(this, null, 'name')}
                    />

                    <Select
                        label='Subaccount van'
                        allowEmpty={true}
                        value={reseller.invoiceResellerId}
                        onChange={this.onChangeValue.bind(this, null, 'invoiceResellerId')}
                    >
                        {resellers.map((reseller) => {
                            return <option key={reseller._id} value={reseller._id}>{reseller.settings?.accountName ? `${reseller.settings.accountName} (${reseller.name})` : reseller.name}</option>
                        })}
                    </Select>

                    <Select
                        label='Onderdeel van'
                        values={reseller.groups || []}
                        options={groupOptions}
                        allowCustomValues
                        onChange={(event) => this.onChangeValues('groups', event)}
                    >
                    </Select>

                    {!reseller.invoiceResellerId &&
                        <>
                            <DatePicker
                                label='Startdatum'
                                value={reseller.startDate}
                                onChange={this.onChangeValue.bind(this, null, 'startDate')}
                            />

                            <Toggle
                                label='Deze reseller niet factureren'
                                checked={reseller.noInvoice}
                                onChange={this.onChangeChecked.bind(this, null, 'noInvoice')}
                            />

                            <Toggle
                                label='BTW verlegd'
                                checked={reseller.reversedVAT}
                                onChange={this.onChangeChecked.bind(this, null, 'reversedVAT')}
                            />

                            <Input
                                label='Debiteurnummer'
                                value={reseller.debtorCode}
                                onChange={this.onChangeValue.bind(this, null, 'debtorCode')}
                            />

                            <Select
                                label='Account type'
                                value={reseller.accountType}
                                onChange={this.onChangeValue.bind(this, null, 'accountType')}
                            >
                                <option value='carrier'>Koerier Standaard</option>
                                <option value='carrierPlus'>Koerier Plus</option>
                            </Select>

                            <Toggle
                                label='Vestiging beheer aan/uit'
                                checked={reseller.prices.branchManagement}
                                onChange={this.onChangeChecked.bind(this, 'prices', 'branchManagement')}
                            />

                            <Input
                                label='Referentie (wordt meegestuurd naar Jortt)'
                                value={reseller.reference}
                                onChange={this.onChangeValue.bind(this, null, 'reference')}
                            />

                            <TextArea
                                style={{marginTop: 24}}
                                label='Notities'
                                rows={10}
                                value={reseller.notes}
                                onChange={this.onChangeValue.bind(this, null, 'notes')}
                            />
                        </>
                    }
                </FormStack>

                {!reseller.invoiceResellerId &&
                    <>
                        <H4 style={{marginTop: 48, marginBottom: 24}}>Tarieven</H4>

                        <FormStack style={{marginBottom: reseller.prices.customPrices ? 0 : 12}}>
                            <Toggle
                                label='Compensatie voor nieuwe tariefmodel (alleen in overgangsperiode okt 2025 - mrt 2026)'
                                checked={reseller.prices.compensation}
                                onChange={this.onChangeChecked.bind(this, 'prices', 'compensation')}
                            />

                            <Input
                                label='Minimum aantal licenties'
                                type='number'
                                value={reseller.prices.minNrOfLicenses || 1}
                                onChange={this.onChangeValue.bind(this, 'prices', 'minNrOfLicenses')}
                            />

                            <Input
                                label='Aantal gratis licenties'
                                type='number'
                                value={reseller.prices.nrOfFreeLicenses || 0}
                                onChange={this.onChangeValue.bind(this, 'prices', 'nrOfFreeLicenses')}
                            />

                            <Toggle
                                label='Custom tarieven'
                                checked={reseller.prices.customPrices}
                                onChange={this.onChangeChecked.bind(this, 'prices', 'customPrices')}
                            />

                            {reseller.prices.customPrices &&
                                <Toggle
                                    label={t('applyLicenseStaffelMax')}
                                    info={t('applyLicenseStaffelMaxInfo')}
                                    checked={reseller.prices.applyLicenseStaffelMax}
                                    onChange={this.onChangeChecked.bind(this, 'prices', 'applyLicenseStaffelMax')}
                                />
                            }

                            {reseller.prices.customPrices &&
                                <FormRow gap={formSpacing.section * 2}>
                                    <div style={{flex: 1}}>
                                        <H6 style={{marginBottom: 12}}>Licenties</H6>

                                        <FormStack>
                                            {reseller.prices.licenses.map((licensePrice, index) => {
                                                const isLastPrice = index === reseller.prices.licenses.length - 1

                                                return (
                                                    <FormRow key={`licensePrice${index}`}>
                                                        <Input
                                                            type={isLastPrice ? '' : 'number'}
                                                            label={isLastPrice ? 'Vanaf' : 't/m'}
                                                            readOnly={isLastPrice}
                                                            value={isLastPrice ? `${reseller.prices.licenses[index - 1]?.max || 0} +` : licensePrice.max}
                                                            onChange={this.onChangePrice.bind(this, 'licenses', index, 'max')}
                                                        />

                                                        <CurrencyInput
                                                            value={licensePrice.price}
                                                            onChange={this.onChangePrice.bind(this, 'licenses', index, 'price')}
                                                        />

                                                        <IconButton onClick={this.onClickRemovePrice.bind(this, 'licenses', index)}><i className='mdi mdi-delete' /></IconButton>
                                                    </FormRow>

                                                )
                                            })}

                                            <Button
                                                variant='outline-white'
                                                icon='mdi mdi-plus'
                                                label='Nieuwe staffel'
                                                onClick={this.onClickAddPrice.bind(this, 'licenses')}
                                            />
                                        </FormStack>
                                    </div>

                                    <div style={{flex: 1}}>
                                        <H6 style={{marginBottom: 12}}>Ritten</H6>

                                        <FormStack>
                                            {reseller.prices.orders.map((orderPrice, index) => {
                                                return (
                                                    <FormRow key={`orderPrice${index}`}>
                                                        <Input
                                                            type='number'
                                                            value={orderPrice.max}
                                                            onChange={this.onChangePrice.bind(this, 'orders', index, 'max')}
                                                        />

                                                        <CurrencyInput
                                                            value={orderPrice.price}
                                                            onChange={this.onChangePrice.bind(this, 'orders', index, 'price')}
                                                        />

                                                        <IconButton onClick={this.onClickRemovePrice.bind(this, 'orders', index)}><i className='mdi mdi-delete' /></IconButton>
                                                    </FormRow>

                                                )
                                            })}

                                            <Button
                                                variant='outline-white'
                                                icon='mdi mdi-plus'
                                                label='Nieuwe staffel'
                                                onClick={this.onClickAddPrice.bind(this, 'orders')}
                                            />
                                        </FormStack>
                                    </div>

                                    <div style={{flex: 1}}>
                                        <H6 style={{marginBottom: 12}}>Zendingen</H6>

                                        <FormStack>
                                            {reseller.prices.parcels.map((parcelPrice, index) => {
                                                return (
                                                    <FormRow key={`parcelPrice${index}`}>
                                                        <Input
                                                            type='number'
                                                            value={parcelPrice.max}
                                                            onChange={this.onChangePrice.bind(this, 'parcels', index, 'max')}
                                                        />

                                                        <CurrencyInput
                                                            value={parcelPrice.price}
                                                            onChange={this.onChangePrice.bind(this, 'parcels', index, 'price')}
                                                        />

                                                        <IconButton onClick={this.onClickRemovePrice.bind(this, 'parcels', index)}><i className='mdi mdi-delete' /></IconButton>
                                                    </FormRow>

                                                )
                                            })}

                                            <Button
                                                variant='outline-white'
                                                icon='mdi mdi-plus'
                                                label='Nieuwe staffel'
                                                onClick={this.onClickAddPrice.bind(this, 'parcels')}
                                            />
                                        </FormStack>
                                    </div>
                                </FormRow>
                            }
                        </FormStack>
                    </>
                }

                <H4 style={{marginTop: 48, marginBottom: 24}}>Herhaalde factuurregels (maandelijks)</H4>

                <FormStack>
                    {reseller?.repeatedInvoiceRules?.map((rule, index) => {
                        return (
                            <FormRow key={`rule${index}`}>
                                <Input
                                    label='Omschrijving'
                                    value={rule.description}
                                    onChange={(event) => {
                                        const newRule = {...rule, description: event.target.value}
                                        this.onChangeValue('repeatedInvoiceRules', index, {target: {value: newRule}})
                                    }}
                                />

                                <CurrencyInput
                                    value={rule.price}
                                    onChange={(event) => {
                                        const newRule = {...rule, price: parsePrice(event.target.value)}
                                        this.onChangeValue('repeatedInvoiceRules', index, {target: {value: newRule}})
                                    }}
                                />

                                <IconButton
                                    onClick={() => {
                                        const reseller = {...this.state.reseller}

                                        reseller.repeatedInvoiceRules.splice(index, 1)

                                        this.setState({reseller})
                                    }}
                                    icon='mdi mdi-delete'
                                />
                            </FormRow>
                        )
                    })}

                    <Button
                        variant='outline-white'
                        icon='mdi mdi-plus'
                        label='Nieuwe regel'
                        onClick={() => {
                            const reseller = {...this.state.reseller}

                            reseller.repeatedInvoiceRules = reseller.repeatedInvoiceRules || []
                            reseller.repeatedInvoiceRules.push({description: '', price: 0})

                            this.setState({reseller})
                        }}
                    />
                </FormStack>

                <H4 style={{marginTop: 48, marginBottom: 24}}>{t('settings')}</H4>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Select
                        label={t('adminOrderPartners')}
                        allowEmpty={true}
                        values={reseller.orderPartners || []}
                        options={resellers.map((partner) => {
                            if (partner._id !== reseller._id) {
                                return {value: partner._id, title: partner.name}
                            }
                        })}
                        onChange={this.onChangeValues.bind(this, 'orderPartners')}
                    />

                    <Toggle
                        label={t('adminConnectionAvailable', {name: 'PostNL-Monta'})}
                        checked={reseller.msgPostNLenabled}
                        info={t('adminConnectionAvailableInfo')}
                        onChange={this.onChangeChecked.bind(this, null, 'msgPostNLenabled')}
                    />

                    <Toggle
                        label={t('adminConnectionAvailable', {name: 'DHL-Monta'})}
                        checked={reseller.msgDHLenabled}
                        info={t('adminConnectionAvailableInfo')}
                        onChange={this.onChangeChecked.bind(this, null, 'msgDHLenabled')}
                    />

                    <Toggle
                        label={t('adminConnectionAvailable', {name: 'QLS'})}
                        checked={reseller.qlsEnabled}
                        info={t('adminConnectionAvailableInfo')}
                        onChange={this.onChangeChecked.bind(this, null, 'qlsEnabled')}
                    />

                    <Toggle
                        label={t('adminConnectionAvailable', {name: 'Intrapost'})}
                        checked={reseller.intrapostEnabled}
                        info={t('adminIntrapostEnabledInfo')}
                        onChange={this.onChangeChecked.bind(this, null, 'intrapostEnabled')}
                    />

                    <Toggle
                        label={t('snelstartWebshopAvailable')}
                        checked={reseller.snelstartWebshopEnabled}
                        info={t('snelstartWebshopAvailableInfo')}
                        onChange={this.onChangeChecked.bind(this, null, 'snelstartWebshopEnabled')}
                    />

                    {!reseller.invoiceResellerId &&
                        <>
                            <Toggle
                                label={t('adminCustomBrandingEnabled')}
                                info={t('adminCustomBrandingEnabledInfo')}
                                checked={reseller.customBrandingEnabled}
                                onChange={this.onChangeChecked.bind(this, null, 'customBrandingEnabled')}
                            />

                            {reseller.customBrandingEnabled &&
                                <Input
                                    label={t('adminDomain')}
                                    value={reseller.settings.domain}
                                    onChange={this.onChangeValue.bind(this, 'settings', 'domain')}
                                    info={t('adminDomainInfo')}
                                />
                            }
                        </>
                    }

                    <Toggle
                        label={t('adminAllowCustomerContracts')}
                        checked={reseller.allowCustomerContracts}
                        onChange={this.onChangeChecked.bind(this, null, 'allowCustomerContracts')}
                    />

                    <Toggle
                        label={t('shiftTargetsEnabled')}
                        checked={reseller.shiftTargetsEnabled}
                        onChange={this.onChangeChecked.bind(this, null, 'shiftTargetsEnabled')}
                    />
                </FormStack>

                <H4 style={{marginTop: 48, marginBottom: 24}}>Modules</H4>
                <Check
                    label='Ritten'
                    checked={reseller.permissions.orders}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'orders')}
                />
                <Check
                    label='Zendingen'
                    checked={reseller.permissions.parcels}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'parcels')}
                />
                <Check
                    label='Diensten'
                    checked={reseller.permissions.shifts}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'shifts')}
                />
                <Check
                    label='Urenregistratie'
                    checked={reseller.permissions.paychecks}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'paychecks')}
                />
                <Check
                    label='Abonnementen'
                    checked={reseller.permissions.subscriptions}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'subscriptions')}
                />
                <Check
                    label='Facturatie'
                    checked={reseller.permissions.invoices}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'invoices')}
                />
                <Check
                    label='Voertuigen'
                    checked={reseller.permissions.vehicles}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'vehicles')}
                />
                <Check
                    label='Klanten'
                    checked={reseller.permissions.customers}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'customers')}
                />

                <Check
                    label='Rapportage'
                    checked={reseller.permissions.analytics}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'analytics')}
                />

                <Check
                    label='Zendinginvoer OCR'
                    checked={reseller.permissions.parcelOCR}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'parcelOCR')}
                />

                <Check
                    label='Netwerk'
                    checked={reseller.permissions.network}
                    onChange={this.onChangeChecked.bind(this, 'permissions', 'network')}
                />

                {!reseller._id &&
                    <>
                        <br />
                        <br />
                        <H4>Gebruiker</H4>
                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Naam'
                                value={user.name}
                                onChange={this.onChangeValueUser.bind(this, 'name')}
                            />
                            <Input
                                label='Emailadres'
                                value={user.email}
                                onChange={this.onChangeValueUser.bind(this, 'email')}
                            />
                        </FormStack>
                    </>
                }

                <br />
                {message &&
                    <Alert style={{marginBottom: 6}} variant='success' dismissible onClose={() => this.setState({message: ''})}>
                        {message}
                    </Alert>
                }
                {error &&
                    <Alert style={{marginBottom: 6}} variant='danger' dismissible onClose={() => this.setState({error: ''})}>
                        {error}
                    </Alert>
                }

                <div style={{display: 'flex', columnGap: formSpacing.columnGap}}>
                    {reseller._id &&
                        <>
                            <Button variant='error' disabled={loading} onClick={() => this.removePopup.open(reseller)}>Verwijder</Button>
                            <Button onClick={() => this.archivePopup.open(reseller)} disabled={loading}>{reseller.isArchived ? 'Activeer' : 'Archiveer'}</Button>
                        </>
                    }

                    <div style={{flex: 1}} />

                    <Button variant='text' disabled={loading} onClick={this.onClickCancel.bind(this)}>Annuleren</Button>
                    <Button onClick={this.onClickSave.bind(this)} loading={loading}>Opslaan</Button>

                </div>

                <RemovePopup ref={(ref) => this.removePopup = ref} />
                <ArchivePopup ref={(ref) => this.archivePopup = ref} viewArchived={viewArchived} />
            </>
        )
    }
}

export default (EditReseller)
